import { getAnalytics, logEvent } from "firebase/analytics";

class FirebaseService {
    logEvent(event_name, item) {
        const analytics = getAnalytics();
        logEvent(analytics, event_name, item);
    }
}

export default new FirebaseService();